import {Component, inject, OnInit} from '@angular/core';
import {ToastService} from "../../../services/toast.service";
import {AuthService} from "../../../services/auth.service";
import {StorageService} from "../../../services/storage.service";
import {SessionService} from "../../../services/session.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {PasswordConfirmationValidator} from "../../../validators/passwordConfirmationValidator";

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  standalone: false
})
export class SignInComponent implements OnInit {
  isRememberMeChecked: any;
  registrationForm!: FormGroup;
  isSignedInProgress: any;
  isPasswordShown: boolean = false;
  isEmailVerificationNeeded: boolean = true;
  registeredEmail: any;
  readonly rememberMeKey = 'remember_me';

  private readonly toastService = inject(ToastService);
  private readonly authService = inject(AuthService);
  private readonly storageService = inject(StorageService);
  private readonly fb = inject(FormBuilder);
  private readonly sessionService = inject(SessionService);

  ngOnInit() {
    const rememberMe = this.storageService.getValue(this.rememberMeKey);
    let defaultEmail = '';
    if (rememberMe != null) {
      const rememberMeObj = JSON.parse(rememberMe);
      defaultEmail = rememberMeObj.email;
      this.isRememberMeChecked = rememberMeObj.remember_me;
    }

    this.registrationForm = this.fb.group({
        email: [defaultEmail,
          [Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+"), Validators.required]],
        password: ['',
          [Validators.required]]
      },
      {validator: PasswordConfirmationValidator.validatePasswordMatch('password', 'confirmPassword')});
  }

  async logIn() {
    this.registrationForm.markAllAsTouched();
    if (this.registrationForm.invalid) {
      this.toastService.showToast('Please fill out all required fields.', 'error');
      return;
    }

    this.isSignedInProgress = true;
    const formValues = this.registrationForm.value;
    this.registeredEmail = formValues.email;
    this.authService.auth(formValues.email, formValues.password)
      .then(async (res: any) => await this.handleAuth(res))
      .catch(() => {
        this.toastService.showToast("Authentication failed", "error")
        this.isSignedInProgress = false;
      });
  }

  private async handleAuth(res: any) {
    if (res.isSuccess == false) {
      if (res.error.code == 116) {
        this.isEmailVerificationNeeded = false;
      } else {
        this.toastService.showToast(res.error.error, "error");
      }
      this.isSignedInProgress = false;
      return;
    }
    await this.sessionService.Login();
    if (this.isRememberMeChecked) {
      this.storageService.setValue(this.rememberMeKey, JSON.stringify({
        email: this.registrationForm.value.email,
        remember_me: this.isRememberMeChecked
      }));
    }
    this.isSignedInProgress = false;
  }

  isInvalidAndTouched(controlName: string): boolean {
    const control = this.registrationForm.get(controlName);
    return control != null && control.invalid && (control.dirty || control.touched);
  }

  isTokenSet() {
    return this.isSignedInProgress;
  }

  toggleShowPassword() {
    this.isPasswordShown = !this.isPasswordShown;
  }

  resendVerification() {
    this.authService.resentEmailVerification(this.registeredEmail)
      .then((res: any) => {
        if (!res.isSuccess) {
          this.toastService.showToast(res.error.error, "error");
          return;
        }
        this.toastService.showToast("Verification email has been sent", "success");
        setTimeout(() => document.location.reload(), 5000);
      })
      .catch(() => this.toastService.showToast("Authentication failed", "error"));
  }
}
